<div class="component-wrapper">
    <section-info></section-info>
    <div>
      <kendo-grid [data]="gridView" 
      (remove)="removeHandler($event)" 
      (add)="createMilestone()" 
      (edit)="editMilestone($event)" 
      [sort]="sort" 
      [sortable]="true">
          <ng-template kendoGridToolbarTemplate *ngIf="!scheduleDataForm.disabled">
            <button kendoGridAddCommand kendoButton class="add-button">
              <span translate>schedule-data.grid.add</span>
              <i class="fa fa-plus" style="margin-left: 0.5rem;"></i>
            </button>
          </ng-template>
  
          <kendo-grid-column title="{{'schedule-data.grid.subject' | translate}}" field="betreff" [width]="200">
              <ng-template kendoGridCellTemplate let-dataItem>
                <div *ngIf="dataItem?.betreff != null || dataItem?.betreff != ''">
                  <span>
                    {{ dataItem.betreff }}
                  </span>
                </div>
              </ng-template>
          </kendo-grid-column>
  
          <kendo-grid-column title="{{'schedule-data.grid.datePlan' | translate}}" field="datumPlan" [width]="100" editor="date">
              <ng-template kendoGridCellTemplate let-dataItem>
                <div *ngIf="dataItem?.datumPlan != null">
                  <span>
                    {{ dataItem?.datumPlan | date: langService.GetCurrentShortDateFormat() }}
                  </span>
                </div>
              </ng-template>
          </kendo-grid-column>
  
          <kendo-grid-column title="{{'schedule-data.grid.dateActual' | translate}}" field="datumIst" [width]="100" editor="date">
              <ng-template kendoGridCellTemplate let-dataItem>
                <div *ngIf="dataItem?.datumIst != null">
                  <span>
                    {{ dataItem?.datumIst | date: langService.GetCurrentShortDateFormat() }}
                  </span>
                </div>
              </ng-template>
          </kendo-grid-column>
  
          <kendo-grid-column title="{{'schedule-data.grid.location' | translate}}" field="ort" [width]="150">
              <ng-template kendoGridCellTemplate let-dataItem>
                <div *ngIf="dataItem?.ort != null || dataItem?.ort != ''">
                  <span>
                    {{ dataItem.ort }}
                  </span>
                </div>
              </ng-template>
          </kendo-grid-column>
  
          <kendo-grid-column title="{{'schedule-data.grid.description' | translate}}" field="beschreibung" [width]="250">
              <ng-template kendoGridCellTemplate let-dataItem>
                <div *ngIf="dataItem?.beschreibung != null || dataItem?.beschreibung != ''">
                  <span>
                    {{ dataItem.beschreibung }}
                  </span>
                </div>
              </ng-template>
          </kendo-grid-column>
  
          <kendo-grid-command-column [width]="180" *ngIf="!scheduleDataForm.disabled">
              <ng-template kendoGridCellTemplate let-isNew="isNew">
                <button kendoGridEditCommand kendoButton [title]="'schedule-data.dialog.titleEdit' | translate" class="edit-button">
                  <i class="fa fa-pen"></i>
                </button>
        
                <button kendoGridRemoveCommand kendoButton [title]="'schedule-data.dialog.titleDelete' | translate" class="delete-button">
                  <i class="fa fa-trash"></i>
                </button>
              </ng-template>
            </kendo-grid-command-column>
      </kendo-grid>
    </div>
</div>